import { render } from "./EditProductView.vue?vue&type=template&id=07c061da&scoped=true&ts=true"
import script from "./EditProductView.vue?vue&type=script&lang=ts"
export * from "./EditProductView.vue?vue&type=script&lang=ts"

import "./EditProductView.vue?vue&type=style&index=0&id=07c061da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07c061da"]])

export default __exports__